export const PHONE_DISPLAY = "0468 320 157";
export const PHONE_HREF = "tel:+61468320157";
export const PHONE_E164 = "+61468320157";
export const SOCIALS = [
  "https://www.instagram.com/yahav.vce/",
  "https://www.facebook.com/tutorsmelbourne",
];
